(function () {
  function pauseVideosIn(root, exceptContainer) {
    if (!root) return;
    root.querySelectorAll('video').forEach(function (video) {
      if (exceptContainer && exceptContainer.contains(video)) return;
      video.pause();
    });
  }

  function activeSwiperSlide(swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return null;
    return swiper.slides[swiper.activeIndex] || null;
  }

  function bindSwiperGallery(swiper, root) {
    if (!swiper || !root) return;
    if (swiper.__pdpGalleryVideosBound) return;
    swiper.__pdpGalleryVideosBound = true;

    var sync = function () {
      var activeSlide = activeSwiperSlide(swiper);
      pauseVideosIn(root, activeSlide);
    };

    swiper.on('slideChange', sync);
    swiper.on('slideChangeTransitionEnd', sync);
    sync();
  }

  function pauseBuyBoxGallery(scope) {
    if (!scope) return;
    var activeSlide = scope.querySelector('[data-buy-box-slide].is-active');
    pauseVideosIn(scope, activeSlide);
  }

  window.PdpGalleryVideos = {
    pauseIn: pauseVideosIn,
    bindSwiper: bindSwiperGallery,
    pauseBuyBox: pauseBuyBoxGallery,
  };
})();
